import React from 'react';
import { PopupNotification } from './components/PopupNotification';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { MiniTestimonials } from './components/MiniTestimonials';
import { PainSection } from './components/PainSection';
import { ProductSection } from './components/ProductSection';
import { BonusesSection } from './components/BonusesSection';
import { UrgencyCountdown } from './components/UrgencyCountdown';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <div className="w-full min-h-screen bg-bg-main text-[#2C2C2C] font-serif overflow-x-hidden" data-id="element-0">
      <PopupNotification data-id="element-1" />
      <UrgencyBar data-id="element-2" />
      <HeroSection data-id="element-3" />
      <MiniTestimonials data-id="element-4" />
      <PainSection data-id="element-5" />
      <ProductSection data-id="element-6" />
      <BonusesSection data-id="element-7" />
      <UrgencyCountdown data-id="element-8" />
      <PricingSection data-id="element-9" />
      <ComparisonTable data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <TestimonialsSection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <FooterSection data-id="element-15" />
    </div>;
}